import { render } from "./OrganizationField.vue?vue&type=template&id=6f6c870d"
import script from "./OrganizationField.vue?vue&type=script&lang=ts"
export * from "./OrganizationField.vue?vue&type=script&lang=ts"
script.render = render

export default script